module.exports = __webpack_public_path__ + "static/assets/e358c7822381e3c4c3ba44afb45cda8f.svg";